import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-212648b8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "transport-icon-cell" };
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("td", null, null, -1 /* HOISTED */); });
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1 /* HOISTED */); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1 /* HOISTED */); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1 /* HOISTED */); });
var _hoisted_6 = { class: "team-icon-cell" };
var _hoisted_7 = { class: "team-icon-cell" };
var _hoisted_8 = {
    key: 0,
    style: { width: '12ch', textAlign: 'right' }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_TransportMarker = _resolveComponent("TransportMarker");
    var _component_TextData = _resolveComponent("TextData");
    var _component_OriginDestination = _resolveComponent("OriginDestination");
    var _component_TeamMarker = _resolveComponent("TeamMarker");
    var _component_n_button = _resolveComponent("n-button");
    return (_openBlock(), _createElementBlock("tr", {
        class: _normalizeClass(["transport-row", { active: _ctx.transport.isActive }]),
        onClick: _cache[2] || (_cache[2] =
            //@ts-ignore
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return (_ctx.onSelectedRow && _ctx.onSelectedRow.apply(_ctx, args));
            })
    }, [
        _createElementVNode("td", _hoisted_1, [
            _createVNode(_component_TransportMarker, {
                num: _ctx.num,
                status: _ctx.transport.status,
                title: _ctx.formatCoordinates(_ctx.transport.coordinates),
                onClick: _ctx.onInspect
            }, null, 8 /* PROPS */, ["num", "status", "title", "onClick"])
        ]),
        _createElementVNode("td", null, [
            (_ctx.waiting)
                ? (_openBlock(), _createBlock(_component_TextData, {
                    key: 0,
                    variant: "xxs"
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode(_toDisplayString(_ctx.waiting), 1 /* TEXT */)
                    ]; }),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true)
        ]),
        _hoisted_2,
        _createElementVNode("td", null, [
            _createVNode(_component_OriginDestination, {
                origin: _ctx.origin,
                destination: _ctx.destination
            }, null, 8 /* PROPS */, ["origin", "destination"])
        ]),
        _createElementVNode("td", null, [
            _createVNode(_component_TextData, { variant: "xxs" }, {
                default: _withCtx(function () { return [
                    _createTextVNode(_toDisplayString(_ctx.nbOfSeatBelts) + " ", 1 /* TEXT */),
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_ctx.nbOfPassengers), 1 /* TEXT */)
                ]; }),
                _: 1 /* STABLE */
            })
        ]),
        _createElementVNode("td", null, [
            _createVNode(_component_TextData, { variant: "xxs" }, {
                default: _withCtx(function () { return [
                    (_ctx.transport.manualCar)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("🚗"),
                            _hoisted_4,
                            _createTextVNode("Manuelle")
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("🚙"),
                            _hoisted_5,
                            _createTextVNode("Automatique")
                        ], 64 /* STABLE_FRAGMENT */))
                ]; }),
                _: 1 /* STABLE */
            })
        ]),
        _createElementVNode("td", _hoisted_6, [
            (_ctx.assignedTeam)
                ? (_openBlock(), _createBlock(_component_TeamMarker, {
                    key: 0,
                    team: _ctx.assignedTeam,
                    style: { "cursor": "pointer" },
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.onInspectTeam(_ctx.assignedTeam)); })
                }, null, 8 /* PROPS */, ["team"]))
                : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("td", _hoisted_7, [
            (_ctx.autoAssignedTeam)
                ? (_openBlock(), _createBlock(_component_TeamMarker, {
                    key: 0,
                    team: _ctx.autoAssignedTeam,
                    style: { "cursor": "pointer" },
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.onInspectTeam(_ctx.autoAssignedTeam)); })
                }, null, 8 /* PROPS */, ["team"]))
                : _createCommentVNode("v-if", true)
        ]),
        (_ctx.isEditable)
            ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                _createVNode(_component_n_button, {
                    size: "small",
                    style: { marginRight: '5px' },
                    onClick: _ctx.onEdit
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode("edit")
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createVNode(_component_n_button, {
                    size: "small",
                    onClick: _ctx.onDelete
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode("del")
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
            ]))
            : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */));
}
